import script from "./HeroldAtZipModal.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroldAtZipModal.vue?vue&type=script&setup=true&lang=js"

import "./HeroldAtZipModal.vue?vue&type=style&index=0&id=66145773&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66145773"]])

export default __exports__